import { columnsPodcast } from '@/domain/env/colums-podcast';
import { DOCUMENTS_DB } from '@/domain/env/documents-db';
import { Podcast } from '@/domain/types/collections';
import usePaginatedDocuments from '@/domain/use-cases/get-paginated-documents';
import Button from '@/presentation/components/button';
import LoadMoreButton from '@/presentation/components/load-more-button';
import Table from '@/presentation/components/table';
import { useState } from 'react';
import { FiPlus } from 'react-icons/fi';
import { Link, useNavigate } from 'react-router-dom';

const PodcastsPage = () => {
  const navigate = useNavigate();
  const [filter, setFilter] = useState<'all' | 'podcast' | 'audio'>('all');
  const { data, error, isLoading, isLoadingMore, hasMore, loadMore } =
    usePaginatedDocuments<Podcast>(DOCUMENTS_DB.PODCASTS);

  if (isLoading) return <div>Loading...</div>;

  if (error) return <div>Error: {error}</div>;

  if (!data.length && !isLoading) return <div>No hay datos</div>;

  const handleRowClick = (row: Podcast) => {
    navigate(`/dashboard/podcasts/details/${row.id}`);
  };

  // Filtrar datos según la categoría seleccionada
  const filteredData =
    filter === 'all' ? data : data.filter((item) => item.category === filter);

  return (
    <div className="p-4 flex flex-col gap-4">
      <div className="flex justify-between items-center">
        <h1 className="text-3xl font-bold">Audios</h1>

        <Link to="/dashboard/podcasts/add">
          <Button label="Agregar audio" icon={<FiPlus />} onClick={() => {}} />
        </Link>
      </div>

      {/* Filtros */}
      <div className="flex gap-2 bg-white p-4 rounded-lg shadow-md">
        <Button
          label={`Todos (${data.length})`}
          onClick={() => setFilter('all')}
          variant={filter === 'all' ? 'primary' : 'ghost'}
        />
        <Button
          label={`Podcasts (${data.filter((item) => item.category === 'podcast').length})`}
          onClick={() => setFilter('podcast')}
          variant={filter === 'podcast' ? 'primary' : 'ghost'}
        />
        <Button
          label={`Audios (${data.filter((item) => item.category === 'audio').length})`}
          onClick={() => setFilter('audio')}
          variant={filter === 'audio' ? 'primary' : 'ghost'}
        />
      </div>

      <Table
        data={filteredData}
        columns={columnsPodcast}
        onRowClick={handleRowClick}
      />

      <LoadMoreButton
        hasMore={hasMore}
        isLoadingMore={isLoadingMore}
        onLoadMore={loadMore}
      />
    </div>
  );
};

export default PodcastsPage;
